module.exports = __webpack_public_path__ + "img/count.2fa85b48.png";